module.exports = __webpack_public_path__ + "media/Loops 90 Strings.e5ed8fd5.wav";